import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, Grid } from '@material-ui/core';
import AppBarModal from '../../general/AppBarModal';
import { BtnForm } from "../../general/BotonesAccion";
import TareasTerminadas from '../../general/TareasTerminadas';
import BuscarSelect from '../../general/BuscarSelect';
import emma_w from '../../../global/imagenes/emma_w.png';
import { obtenerValoresFiltros, transformar } from "../../../global/js/funciones";
import { ESTADOS_BIENESTAR, CARRERAS_CUC, TIPOS_SERV, TIPOS_SOL, COD_ESTADO_TODOS } from '../helper';
import InputBuscar from '../../general/InputBuscar';
import BuscarPersona from '../../general/BuscarPersona';
import { fetchPeriodosBienestar } from './services/bienestarDetalleService';


class BienestarFiltro extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estados: [],
            tiposServicio: [],
            periodos: [],
            tiposSolicitud:[],
            tipoSolicitud: null,
            estado: null,
            tipoServicio: null,
            periodo: null,
            cargando: true,
            cargar: true,
            buscarEstudiante: false,
            estudiante: {
                id: 0,
                nombre: ''
            },
            programa: null,
            programas:[]
        };
    }

    obtenerPeriodos = () => {
        return fetchPeriodosBienestar();
    };


    async componentDidUpdate({ modalAddFiltrosBienestar, accionProceso }) {
        let { modalAddFiltrosBienestar: modalAddFiltrosBienestarNew, accionProceso: accionProcesoNew } = this.props;
        let { cargar } = this.state;
        
        if (modalAddFiltrosBienestar !== modalAddFiltrosBienestarNew && modalAddFiltrosBienestarNew) {
            this.setState({
                estado: null,
                tipoServicio: null,
                periodo: null,
                tipoSolicitud: null,
                programa: null,
                estudiante: { id: 0, nombre: '' },
                buscarEstudiante: false
            });
        }

        if (modalAddFiltrosBienestar !== modalAddFiltrosBienestarNew && modalAddFiltrosBienestarNew && cargar) {
            this.setState({ cargando: true });
            
            let estados = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': ESTADOS_BIENESTAR }]);
            let programas = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': CARRERAS_CUC}, { 'llave': 'estado', 'valor': 1 }]);
            let tiposServicioBienestar = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_SERV }]);
            let tipoSolicitudBienestar = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': TIPOS_SOL }]);
            let periodos = await this.obtenerPeriodos();
            
            let estadosTransformados = transformar(estados);
            let periodosTransformados = transformar(periodos, 'periodo', 'periodo');
            
            this.setState({
                'estados': estadosTransformados,
                'periodos': periodosTransformados,
                'tiposServicio': transformar(tiposServicioBienestar),
                'tiposSolicitud': transformar(tipoSolicitudBienestar),
                'programas': transformar(programas),
                cargando: false,
                cargar: false
            });
        }

        if (accionProceso !== accionProcesoNew && accionProceso !== 'inicio') {
            this.setState({
                estado: null,
                tipoServicio: null,
                periodo: null,
            });
        }
    }

    resetState = () => {
        let { limpiar, mostrarModalAddFiltrosBienestar } = this.props;
        this.setState({
            estado: null,
            tipoServicio: null,
            periodo: null,
            tipoSolicitud: null,
            programa: null,
            estudiante: {
                id: 0,
            }
        });
        limpiar();
        mostrarModalAddFiltrosBienestar(false);
    };

    onSubmit = e => {
        e.preventDefault();
        let { filtrar, actualizarMensaje, accionProceso, mostrarTodos, mostrarModalAddFiltrosBienestar, mostrarCampos, aplicarPeriodo } = this.props;
        let { periodo, tipoServicio, tipoSolicitud, programa, estudiante } = this.state;

        if (!mostrarCampos) {
            if (!periodo) {
                actualizarMensaje({ titulo: 'Seleccione un periodo', tipo: 'info', mostrar: true, tiempo: 6000 });
                return;
            }
            mostrarModalAddFiltrosBienestar(false);
            if (aplicarPeriodo) aplicarPeriodo(periodo.value);
            return;
        }

        let filtros = [];
        if (periodo !== null) {
            filtros.push({ 'llave': 'periodo', 'valor': periodo.value });
        }
        if (tipoServicio !== null) {
            filtros.push({ 'llave': 'tipo_servicio', 'valor': tipoServicio.value });
        }
        if(tipoSolicitud !== null){
            filtros.push({ 'llave': 'tipo_solicitud', 'valor': tipoSolicitud.value });
        }
        if (programa !== null) {
            filtros.push({ 'llave': 'programa', 'valor': programa.value });
        }
        if (estudiante.id) {
            filtros.push({ 'llave': 'usuario_registro', 'valor': estudiante.id });
        }

        if (filtros.length > 0) {
            mostrarTodos(COD_ESTADO_TODOS);
            mostrarModalAddFiltrosBienestar(false);
            filtrar(filtros);
        } else {
            actualizarMensaje({ titulo: 'Seleccione algún filtro', tipo: 'info', mostrar: true, tiempo: 6000 });
        }
    };

    render() {
        let { modalAddFiltrosBienestar, mostrarModalAddFiltrosBienestar, accionProceso, mostrarCampos } = this.props;
        let { periodo, estado, tipoServicio, estados, periodos, tiposServicio, cargando, buscarEstudiante, estudiante, programa, programas, tiposSolicitud, tipoSolicitud } = this.state;
        let habilitar_limpiar = accionProceso !== COD_ESTADO_TODOS && accionProceso !== 'inicio';

        return (
            <>
            <Dialog 
                fullWidth={true} 
                maxWidth="sm" 
                open={modalAddFiltrosBienestar} 
                onClose={() => mostrarModalAddFiltrosBienestar(false)} 
                aria-labelledby="bienestar-filtro-title"
            >
                <AppBarModal 
                    titulo='¡ Aplicar Filtros !' 
                    mostrarModal={mostrarModalAddFiltrosBienestar} 
                    titulo_accion={habilitar_limpiar ? "Limpiar" : ''} 
                    accion={habilitar_limpiar ? this.resetState : ''} 
                />
                <DialogContent className='scroll'>
                    {cargando ? (
                        <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />
                    ) : (
                        <Grid container spacing={3} className='margin_cont'>
                            {mostrarCampos ? (
                                <>
                                {/* campo de buscar persona */}
                                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                                    <InputBuscar
                                        id='estudiante'
                                        label='Estudiante'
                                        placeholder='Clic aquí para buscar'
                                        value={estudiante.nombre}
                                        callback={() => this.setState({ buscarEstudiante: true })} 
                                    />
                                </Grid>

                                {/* select programa */}
                                <Grid item xs={12} xl={12} sm={12} md={12} lg={12} >
                                    <BuscarSelect datos={programas} cambiarEstado={(value) => this.setState({ programa: value })} valor={programa} id='select-programa' nombre='Programa' placeholder='Seleccione Programa' />
                                </Grid>

                                {/* tipo servicio */}
                                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                                    <BuscarSelect 
                                        datos={tiposServicio} 
                                        cambiarEstado={(value) => this.setState({ tipoServicio: value })} 
                                        valor={tipoServicio} 
                                        id='select-tipo-servicio-bienestar' 
                                        nombre='Tipo de Servicio' 
                                        placeholder='Seleccione Tipo de Servicio' 
                                    />
                                </Grid>

                                {/* tipo solicitud */}
                                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                                    <BuscarSelect 
                                        datos={tiposSolicitud} 
                                        cambiarEstado={(value) => this.setState({ tipoSolicitud: value })} 
                                        valor={tipoSolicitud} 
                                        id='select-tipo-servicio-bienestar' 
                                        nombre='Tipo Solicitud' 
                                        placeholder='Seleccione Tipo de Servicio' 
                                    />
                                </Grid>
                                </>
                            ):(
                                <Grid item xs={12} xl={12} sm={12} md={12} lg={12}>
                                    <BuscarSelect 
                                        datos={periodos} 
                                        cambiarEstado={(value) => this.setState({ periodo: value })} 
                                        valor={periodo} 
                                        id='select-periodo-bienestar' 
                                        nombre='Periodo' 
                                        placeholder='Seleccione Periodo' 
                                    />
                                </Grid>
                            )}
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions>
                    <BtnForm texto="CANCELAR" callback={() => mostrarModalAddFiltrosBienestar(false)} />
                    {!cargando && <BtnForm texto="FILTRAR" callback={this.onSubmit} />}
                </DialogActions>
            </Dialog>

            <Dialog fullWidth={true} maxWidth="sm" fullScreen={window.innerWidth < 600} open={buscarEstudiante} onClose={() => this.setState({ buscarEstudiante: false })}>
                <AppBarModal titulo={'¡ Buscar Estudiante !'} mostrarModal={() => this.setState({ buscarEstudiante: false })} titulo_accion="CERRAR" accion={() => this.setState({ buscarEstudiante: false })} />
                <DialogContent style={{ padding: '0' }} className='scroll'>
                    <BuscarPersona callback={({ id, primer_nombre, primer_apellido, segundo_apellido }) => this.setState({
                    estudiante: {
                        id,
                        nombre: `${primer_nombre} ${primer_apellido} ${segundo_apellido}`,
                    }, buscarEstudiante: false
                    })} />
                </DialogContent>
                <DialogActions>
                    <BtnForm texto="CANCELAR" callback={() => this.setState({ buscarEstudiante: false })} />
                </DialogActions>
            </Dialog>
            </>

        );
    }
}

BienestarFiltro.propTypes = {
    modalAddFiltrosBienestar: PropTypes.bool.isRequired,
    mostrarModalAddFiltrosBienestar: PropTypes.func.isRequired,
    filtrar: PropTypes.func.isRequired,
    limpiar: PropTypes.func.isRequired,
    actualizarMensaje: PropTypes.func.isRequired,
    accionProceso: PropTypes.string.isRequired,
    mostrarTodos: PropTypes.func.isRequired,
    aplicarPeriodo: PropTypes.func,
};

export default BienestarFiltro;